import Button from '../../components/commons/button'
import Badge from '../../components/commons/badge'
import icEyeOpen from '../../assets/images/ic-eye-open.svg'
import icTrash01Red from '../../assets/images/ic-trash-01-red.svg'
import icEdit from '../../assets/images/ic-edit-04-primary.svg'
import icFileDown02 from '../../assets/images/ic-file-down-02.svg'
import icArchive from '../../assets/images/ic-archive.svg'
import { ACTION_TYPE } from '../../constants/constant'
import { formatDateMoment, onOpenFile } from '../../utils/utils'

export const TABLE_SOP = {
    name: 'SOP',
    column: [
        {
            name: 'Name',
            key: 'name',
            className: 'font-semibold',
        },
        {
            name: 'Number',
            key: 'number',
            className: 'font-medium',
        },
        {
            name: 'Category',
            key: 'category',
            className: 'capitalize',
            render: ({ item }) => item?.category?.name || '-',
        },
        {
            name: 'File',
            key: 'document_url',
            classNameHeader: '!text-center',
            render: ({ value }) => (
                <div className='flex justify-center'>
                    {value ? (
                        <Button
                            type='outline'
                            icon={icFileDown02}
                            onClick={() => onOpenFile({ urls: [value] }, 'SOP-File')}
                        />
                    ) : (
                        '-'
                    )}
                </div>
            ),
        },
        {
            name: 'Created Date',
            key: 'created_at',
            className: 'w-[120px]',
            render: ({ value }) => (value ? formatDateMoment(value, 'DD MMM YYYY') : '-'),
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => {
                const badgeType = (value === 'archive' || value === 'archived') ? 'archive' : value
                return <Badge type={badgeType} title={value || '-'} />
            },
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center',
            render: ({ item, onClickItem }) => (
                <div className='flex space-x-3 justify-center'>
                    {item?.status !== 'draft' && (
                        <Button
                            type='outline'
                            icon={icEyeOpen}
                            onClick={() => onClickItem({ item, actionType: ACTION_TYPE.PREVIEW })}
                        />
                    )}
                    {item?.status === 'draft' && (
                        <>
                            <Button
                                type='outline'
                                icon={icEdit}
                                onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                            />
                            <Button
                                type='danger'
                                icon={icTrash01Red}
                                onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                            />
                        </>
                    )}
                    {item?.status === 'active' && (
                        <Button
                            type='outline'
                            icon={icArchive}
                            onClick={() => onClickItem({ item, actionType: ACTION_TYPE.ARCHIVE })}
                        />
                    )}
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY_SOP = {
    page: 1,
    limit: 20,
    search: '',
}

export const SOP_FILTER_LIST = [
    {
        label: 'SOP Category',
        value: 'category_id',
        placeholder: 'Pilih Category',
    },
    {
        label: 'Status',
        value: 'status',
        valueKey: 'id',
    },
    {
        label: 'Created Year',
        value: 'year',
        type: 'select',
        placeholder: 'Pilih Tahun',
    },
]

export const SOP_FILTER_QUERY_PARAMS = {
    category_id: 'category_id',
    status: 'status',
    year: 'year',
}

export const SOP_STATUS_OPTIONS = [
    { id: 'draft', name: 'Draft' },
    { id: 'active', name: 'Active' },
    { id: 'archived', name: 'Archive' },
]
